import EventBus from './../../../bus'

const SAFE_UNUSED_VALUE = ''

const _registerEvent = (eventName, propertyName) => {
    EventBus.$on(eventName, (e) => {
        _eventHandler(e, propertyName)
    })
}

const _eventHandler = (e, propertyName) => {
    const value = e.data[propertyName] || null
    const qs = _getUpdatedQueryString(propertyName, value)

    history.replaceState({ propertyName: value }, SAFE_UNUSED_VALUE, qs)
}

const _getUpdatedQueryString = (propertyName, value) => {
    let searchParams = new URLSearchParams(window.location.search)

    if (Array.isArray(value) || value === null) {
        _deleteAllEntriesForArray(searchParams, propertyName)
    }

    if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
            searchParams.set(`${propertyName}[${i}]`, value[i])
        }
    } else {
        searchParams.set(propertyName, value)
    }

    const qs = _removeNullsFromSearchParams(searchParams)

    return qs.length === 0 ? window.location.pathname : `?${qs}`
}

const _removeNullsFromSearchParams = (searchParams) => {
    let keysToDelete = []

    searchParams.forEach((value, key) => {
        if (value === 'null' || value === '') {
            keysToDelete.push(key)
        }
    })

    keysToDelete.forEach(key => {
        searchParams.delete(key)
    })

    return searchParams.toString()
}

const _deleteAllEntriesForArray = (searchParams, propertyName) => {
    let toDelete = []

    for (const [key, value] of searchParams.entries()) {
        if (key.startsWith(`${propertyName}[`)) {
            toDelete.push(key)
        }
    }

    // Actual deletion must be done in a separate loop else the iteration gets broken and we dont see all elements
    for (let i = 0; i < toDelete.length; i++) {
        searchParams.delete(toDelete[i])
    }
}

export default {
    registerEvent: _registerEvent
}